export default __webpack_public_path__ + "static/media/photo--sm--chris-5.c9683b23.jpg";